import { uuid } from '../helpers/Util';

const UUID = uuid();
const PREDEFINED_FIRST_LAYER_ID = 'layer-' + UUID;
const PREDEFINED_FIRST_USER_VARIABLE_ID = 'var-' + UUID;
export const PREDEFINED_PALETTE_ID = 'palette-' + UUID;

const DEFAULT_ASSET = {
    SURVEY: {
        appType: 1,
        type: 'Survey',
        title: 'Untitled',
        hasGlobalPage: false,
        allowDownloadCSV: false,
        tabs: [
            {
                title: 'Tab title',
                pages: [
                    {
                        type: 1,
                        text: 'Text description here!',
                    },
                ],
            },
        ],
    },
    SURVEY_WIZARD: {
        appType: 1,
        type: 'Survey',
        title: 'Survey',
        hasGlobalPage: true,
        allowDownloadCSV: false,
        hideBook: true,
        hideType: true,
        context: 'SOCIAL_EXPLORER',
        showResults: true,
        tabs: [
            {
                title: 'Introduction',
                pages: [
                    {
                        type: 1,
                        header:
                            'Welcome! This is your Survey! Click here to change the headline.',
                        text: ' ',
                    },
                ],
            },
            {
                title: 'Survey',
                pages: [
                    {
                        type: 2,
                        questionType: 1,
                        uid: '64577898-ac02-4f92-ad03-63118eb4e06f',
                        text:
                            'This page shows a radio button question. This is one of several different types of questions you can ask.',
                        question: 'What is your favorite color?',
                        showHeaderOnTop: true,
                        questionnaireGroup: 'qGroup00',
                        options: [
                            {
                                label: 'Blue',
                                value: '1',
                            },
                            {
                                label: 'Green',
                                value: '2',
                            },
                            {
                                label: 'Red',
                                value: '3',
                            },
                            {
                                label: 'Yellow',
                                value: '4',
                            },
                            {
                                label: 'Purple',
                                value: '5',
                            },
                            {
                                label: 'Pink',
                                value: '6',
                            },
                            {
                                label: 'Other',
                                value: '7',
                            },
                        ],
                        askToSaveData: true,
                        visibleOnGlobalPage: true,
                        chartDescription: {
                            type: "pie",
                            size: "col1",
                            series: [
                                {
                                    name: "Global"
                                }
                            ]
                        }
                    },
                ],
            },
            {
                title: 'Results',
                pages: [
                    {
                        type: 21,
                        questionResultsTypeID: 1,
                        questionnaireGroup: 'qGroup00',
                        text: 'Results overview',
                        description: '',
                    },
                ],
            },
        ],
    },
    MAPSPICE_MAP: {
        config: {
            template: 'single-map',
        },
        layout: {
            title: {
                enabled: true,
                title: 'Single Map',
            },
            'map-definition': {
                zoomControl: {
                    enabled: true,
                },
            },
        },
        'map-definition': {
            zoom: 3,
            maxZoom: 18,
            bounds: [
                [-128.04049552825643, 19.9211772614824],
                [-62.67132558770979, 55.434458113587624],
            ],
            maxBounds: [
                [-161.2424468375234, -2.886240788405246],
                [-33.38035026110529, 63.24724475523763],
            ],
            center: [-95.35591055797346, 39.925836933074464],
            style: {
                sources: {
                    socialexplorer: {
                        type: 'vector',
                        tiles: [
                            'https://tiles3.vizualist.com/gettile/?x={x}&y={y}&z={z}&layers={layers}&projection=EPSG-3857&columns={columns}',
                        ],
                    },
                },
                layers: [
                    {
                        id: 'US_AK_HI_landmass',
                        paint: {
                            'fill-color': '#fff',
                        },
                        type: 'fill',
                        source: 'socialexplorer',
                        'source-layer': '10930',
                    },
                    {
                        id: 'US_AK_HI_landmass_boundaries',
                        paint: {
                            'line-color': '#999',
                        },
                        type: 'line',
                        source: 'socialexplorer',
                        'source-layer': '10930',
                    },
                ],
            },
        },
    },
    MAPSPICE_WIZARD_MAP: {
        config: {
            template: 'single-map',
        },
        layout: {
            title: {
                enabled: false,
                title: ' ',
            },
            credits: {
                enabled: false,
                text: ' ',
            },
            additionalContent: {
                show: true,
                enabled: false,
                html: ' ',
                title: ' ',
            },
            'map-definition': {
                legend: {
                    enabled: false,
                    show: true,
                    title: ' ',
                },
                variablePicker: {
                    enabled: false,
                    type: 'dropdown',
                    title: 'Choose variable',
                },
                tooltip: {
                    enabled: true,
                    fixed: true,
                    content: [
                        {
                            style: 'h1 bold',
                            valueColumns: '#variableBased',
                            variables: {},
                        },
                        {
                            style: 'h3',
                            valueColumns: '#variableBased',
                            variables: {},
                            valuePrefixes: {},
                            valueSuffixes: {},
                            prefixes: {},
                            overrideNullValues: {},
                        },
                    ],
                },
                zoomControl: {
                    enabled: true,
                },
                locateControl: {
                    enabled: false,
                },
            },
        },
        'map-definition': {
            style: {
                sources: {},
                layers: [],
                metadata: {
                    'mapspice:use-seamless-variable-transitions': true,
                    'mapspice:color-palettes': {
                        [PREDEFINED_PALETTE_ID]: {
                            name: PREDEFINED_PALETTE_ID,
                            type: 'color-array',
                            colors: [
                                '#C6DBEF',
                                '#B0CCE7',
                                '#9ABDDE',
                                '#85AED6',
                                '#719FCC',
                                '#5D91C3',
                                '#4E81B7',
                                '#4072AB',
                                '#33639E',
                                '#255591',
                                '#174784',
                            ],
                        },
                    },
                    'mapspice:use-dynamic-contrast-labels': true,
                    'mapspice:preferred-variable-id': PREDEFINED_FIRST_USER_VARIABLE_ID,
                    'mapspice:variables': {
                        [PREDEFINED_FIRST_USER_VARIABLE_ID]: {
                            name: 'Variable 1',
                            'layers-ids': [PREDEFINED_FIRST_LAYER_ID],
                        },
                    },
                },
                sprite:
                    'https://mapspice-static.socialexplorer.com/static/sprite/sprite',
                glyphs: 'socex://fonts/{fontstack}/{range}.pbf',
                transition: {
                    duration: 600,
                },
            },
        },
    },
    CHART: {
        version: 2,
        project: {
            title: '',
            description: '',
            createdAt: new Date(),
            updatedAt: new Date(),
            dataImportOptions: {
                transpose: false,
            },
            chart: {
                annotations: {},
                legendPosition: 'auto',
                legendBehaviour: 'none',
                titleVisible: false,
                sourceVisible: false,
                xAxisLineVisible: true,
                xAxisMajorTicksVisible: false,
                xAxisLabelsVisible: true,
                xAxisLabelsRotation: 'auto',
                xAxisLabelsStep: 2,
                xAxisMajorGridLinesVisible: false,
                xAxisAllowDecimals: false,
                xAxisTitleVisible: true,
                xAxisTitleRotation: 'horizontal',
                yAxisTitleRotation: 'horizontal',
                yAxes: {
                    '0': {
                        yAxisLineVisible: false,
                        yAxisMajorTicksVisible: false,
                        yAxisMajorGridLinesVisible: true,
                        yAxisLabelsVisible: true,
                        yAxisAllowDecimals: true,
                        yAxisColorAsGrid: true,
                        yAxisTitleVisible: false,
                        yAxisLabelFormat: '{value}%',
                    },
                    '1': {
                        yAxisLineVisible: false,
                        yAxisMajorTicksVisible: false,
                        yAxisMajorGridLinesVisible: true,
                        yAxisLabelsVisible: true,
                        yAxisOpposite: true,
                        yAxisAllowDecimals: true,
                        yAxisColorAsGrid: true,
                        yAxisTitleVisible: false,
                    },
                },
                tableOutline: true,
                alternatingRows: true,
                horizontalLines: true,
                verticalLines: true,
                headerVerticalLines: true,
                tableType: 'normal',
                pieCategoryLabelsPosition: 'above',
                dataSeries: {
                    general: {
                        tooltipEnabled: true,
                        dataLabelsPosition: 'none',
                        dataLabelsValueColumn:
                            '4a656612-cb7d-47bb-834c-1c497af2f2c6',
                        markerSymbol: 'none',
                        tooltipTemplate: '{title}',
                    },
                    nontransposed: {
                        general: {
                            x: '4a656612-cb7d-47bb-834c-1c497af2f2c6',
                        },
                        series: {
                            '45bd8d9b-371b-4d2a-8b8c-cdf3c63c6646': {
                                id: '45bd8d9b-371b-4d2a-8b8c-cdf3c63c6646',
                                x: '4a656612-cb7d-47bb-834c-1c497af2f2c6',
                                y: 'ac37ff49-b683-4acb-8093-cc17fd7837e8',
                                z: 'ac37ff49-b683-4acb-8093-cc17fd7837e8',
                                color: 5,
                                dataLabelsValueColumn:
                                    '4a656612-cb7d-47bb-834c-1c497af2f2c6',
                                yAxis: '0',
                                type: 'column',
                                index: 1000000,
                                colorPalette: [0, 1, 2, 3],
                                dataSerieUsesCustomTooltip: true,
                                tooltipTemplate:
                                    '{title}: <strong>{y}%</strong>',
                            },
                        },
                    },
                },
                stockNavigator: 'navigation',
                transposed: false,
                type: 'line',
                tooltipShared: true,
            },
        },
        columns: [
            {
                type: 0,
                formula: null,
                defaultValue: null,
                featureType: null,
                geoRefColumnId: null,
                metadata: {},
                id: 'f2e8013a-1b36-4938-9c3e-69ed1992b582',
            },
            {
                type: 2,
                formula: null,
                defaultValue: null,
                featureType: null,
                geoRefColumnId: null,
                metadata: {
                    name: 'Year',
                    ordering: 1000000,
                },
                id: '4a656612-cb7d-47bb-834c-1c497af2f2c6',
            },
            {
                type: 2,
                formula: null,
                defaultValue: null,
                featureType: null,
                geoRefColumnId: null,
                metadata: {
                    name: 'Column 1',
                    ordering: 2000000,
                },
                id: 'ac37ff49-b683-4acb-8093-cc17fd7837e8',
            },
            {
                type: 2,
                formula: null,
                defaultValue: null,
                featureType: null,
                geoRefColumnId: null,
                metadata: {
                    name: 'Rural population',
                    ordering: 3000000,
                },
                id: '1e3b3c66-e1bf-47d9-8420-a864ad9b3b5b',
            },
            {
                type: 1,
                formula: null,
                defaultValue: null,
                featureType: null,
                geoRefColumnId: null,
                metadata: {
                    isOrderColumn: true,
                },
                id: '7367bd3d-2828-46e1-8a21-1795fb81ddaf',
            },
            {
                type: 5,
                formula: null,
                defaultValue: 'false',
                featureType: null,
                geoRefColumnId: null,
                metadata: {
                    isSoftDeleteColumn: true,
                },
                id: '471efcc9-91df-4ede-80c7-8b717b8e098f',
            },
        ],
        data: [
            [
                '5c5c2177-6283-b618-7e8e-a11e48b15fa8',
                1960,
                33.56,
                66.44,
                1000000,
                false,
            ],
            [
                'a3533a40-7308-96d9-ee0c-d33cf1b39917',
                1961,
                34.07,
                65.93,
                2000000,
                false,
            ],
            [
                'ab43df8b-2dae-431e-ff0b-f504c074441f',
                1962,
                34.52,
                65.48,
                3000000,
                false,
            ],
            [
                '32592d02-f2e2-b0c5-57db-6647ce9ca4cd',
                1963,
                34.91,
                65.09,
                4000000,
                false,
            ],
            [
                '980b5cbf-3b38-063e-f251-e91d9744143e',
                1964,
                35.3,
                64.7,
                5000000,
                false,
            ],
            [
                'fc8e1cf3-faf8-fb99-8396-26d07b0013d9',
                1965,
                35.53,
                64.47,
                6000000,
                false,
            ],
            [
                'baa016e7-dcab-6fb7-b76b-2ae032696aae',
                1966,
                35.73,
                64.27,
                7000000,
                false,
            ],
            [
                'ad3897a5-492a-4245-3681-95d17d3b80d8',
                1967,
                35.94,
                64.06,
                8000000,
                false,
            ],
            [
                '97d22658-59d9-7fd0-febd-cd7e7fdff65a',
                1968,
                36.13,
                63.87,
                9000000,
                false,
            ],
            [
                '19b4cbc1-d85d-3fac-d490-163942c04e57',
                1969,
                36.34,
                63.66,
                10000000,
                false,
            ],
            [
                '07af332f-4318-d9df-788e-b285708ac56d',
                1970,
                36.53,
                63.47,
                11000000,
                false,
            ],
            [
                'aa68fbcf-452f-ce45-0b13-2b13b76b3fda',
                1971,
                36.71,
                63.29,
                12000000,
                false,
            ],
            [
                '75163572-3507-20b7-7ad1-2084ec154eb9',
                1972,
                36.92,
                63.08,
                13000000,
                false,
            ],
            [
                '4b6b3a2d-eac8-0482-d8c1-e371e9726bf0',
                1973,
                37.15,
                62.85,
                14000000,
                false,
            ],
            [
                '69751309-2fcb-aa11-f4ce-dc639c166271',
                1974,
                37.43,
                62.57,
                15000000,
                false,
            ],
            [
                '605ebae0-ffdd-e4ad-ae89-3deadc6eb463',
                1975,
                37.65,
                62.35,
                16000000,
                false,
            ],
            [
                'f6de3eeb-edaf-10e7-fada-0203cb985a8c',
                1976,
                37.9,
                62.1,
                17000000,
                false,
            ],
            [
                '7cfbcbbd-42e3-1ff8-ea10-3c5a9f517a19',
                1977,
                38.15,
                61.85,
                18000000,
                false,
            ],
            [
                'ee310434-adcb-e9aa-5d39-df423d6432d8',
                1978,
                38.48,
                61.52,
                19000000,
                false,
            ],
            [
                '6d7cbe35-c90f-1569-a431-26918b305456',
                1979,
                38.88,
                61.12,
                20000000,
                false,
            ],
            [
                '8a2c3691-6e60-47ce-eaff-06124be527aa',
                1980,
                39.28,
                60.72,
                21000000,
                false,
            ],
            [
                '55277b20-88bd-a519-06c0-669b46877690',
                1981,
                39.7,
                60.3,
                22000000,
                false,
            ],
            [
                '9fc15871-212f-c52f-97d7-8dc95c8df43e',
                1982,
                40.08,
                59.92,
                23000000,
                false,
            ],
            [
                'b8c46061-2841-c874-be01-fe9a263186d7',
                1983,
                40.42,
                59.58,
                24000000,
                false,
            ],
            [
                '759961ba-f407-7feb-4255-c17ec773a108',
                1984,
                40.78,
                59.22,
                25000000,
                false,
            ],
            [
                '6a00d869-3b2a-0332-3dae-1f488da69b0a',
                1985,
                41.13,
                58.87,
                26000000,
                false,
            ],
            [
                '4b4325de-af33-1b6a-4dbe-5deca54225fe',
                1986,
                41.49,
                58.51,
                27000000,
                false,
            ],
            [
                'a7e065b3-3519-1402-fa2e-5c514f8080a5',
                1987,
                41.85,
                58.15,
                28000000,
                false,
            ],
            [
                '4f8099a7-3bf5-04b6-acc7-68f56fdd8423',
                1988,
                42.22,
                57.78,
                29000000,
                false,
            ],
            [
                'bac32ea5-5b55-262d-92a4-cfdcb40588cc',
                1989,
                42.57,
                57.43,
                30000000,
                false,
            ],
            [
                '9082f759-28d0-fc7f-91b8-75eaba618ea4',
                1990,
                42.93,
                57.07,
                31000000,
                false,
            ],
            [
                'ed73c80e-5085-9499-a4f1-eb81ab465ed1',
                1991,
                43.29,
                56.71,
                32000000,
                false,
            ],
            [
                '6da7d18e-ba7c-734a-7126-13bc5a2e3965',
                1992,
                43.62,
                56.38,
                33000000,
                false,
            ],
            [
                'bd4b11ac-eca6-4f1c-db0e-dcd325c3968d',
                1993,
                43.98,
                56.02,
                34000000,
                false,
            ],
            [
                '48b32d92-3c10-a0d5-28a0-8e84402b56a5',
                1994,
                44.34,
                55.66,
                35000000,
                false,
            ],
            [
                '3d26add7-a000-6f68-678a-95fd7fc9e673',
                1995,
                44.7,
                55.3,
                36000000,
                false,
            ],
            [
                'eef69116-fc34-da70-f896-f6340c237e27',
                1996,
                45.06,
                54.94,
                37000000,
                false,
            ],
            [
                '2d80bd9a-e935-7480-9453-3033bbb1cf2a',
                1997,
                45.42,
                54.58,
                38000000,
                false,
            ],
            [
                '81d7cffa-acbc-799b-7e99-b0aa8820689e',
                1998,
                45.78,
                54.22,
                39000000,
                false,
            ],
            [
                'df507e90-e45a-c946-7de4-4d08fd998947',
                1999,
                46.15,
                53.85,
                40000000,
                false,
            ],
            [
                '8ba9715e-d7d4-9076-7ae9-0a519f63cff5',
                2000,
                46.54,
                53.46,
                41000000,
                false,
            ],
            [
                '87b04945-04b1-8bb1-4f65-d19d8b2a9177',
                2001,
                46.98,
                53.02,
                42000000,
                false,
            ],
            [
                'cd9d7fdc-40ba-0567-d8c7-4d325b0e7a7d',
                2002,
                47.48,
                52.52,
                43000000,
                false,
            ],
            [
                'c1db44d1-2f7d-9930-75e0-7a2131c1ee1c',
                2003,
                47.98,
                52.02,
                44000000,
                false,
            ],
            [
                '8e2c697f-a780-4690-3e97-42351b9c76f1',
                2004,
                48.48,
                51.52,
                45000000,
                false,
            ],
            [
                '72d413d9-3759-e8fe-5c3c-c0b6ab73e900',
                2005,
                48.99,
                51.01,
                46000000,
                false,
            ],
            [
                '47af92df-b551-7401-d7df-a90fb8761325',
                2006,
                49.49,
                50.51,
                47000000,
                false,
            ],
            [
                '16f6871c-90b8-16ff-fb0e-e2f59137e64c',
                2007,
                49.99,
                50.01,
                48000000,
                false,
            ],
            [
                '6cfc94d4-fc34-56e5-7c6f-741c076b24eb',
                2008,
                50.49,
                49.51,
                49000000,
                false,
            ],
            [
                '17d3fe1a-d533-5a43-fc30-6c7af8674a12',
                2009,
                50.99,
                49.01,
                50000000,
                false,
            ],
            [
                '83edd6b0-479b-a686-6059-7acb6481ca5c',
                2010,
                51.48,
                48.52,
                51000000,
                false,
            ],
            [
                '9fad5bb0-ec9a-44eb-b9c4-69daee277869',
                2011,
                51.98,
                48.02,
                52000000,
                false,
            ],
            [
                '9a6ed0ab-c9f1-4c26-bc0e-9d550f03497e',
                2012,
                52.46,
                47.54,
                53000000,
                false,
            ],
            [
                '905730ff-c843-4dad-bcb3-19cda5798112',
                2013,
                52.94,
                47.06,
                54000000,
                false,
            ],
            [
                'c84b7062-d192-457e-825e-2e0b1b3e3649',
                2014,
                53.4,
                46.6,
                55000000,
                false,
            ],
        ],
        theme: {
            id: 'default_spectrum',
        },
    },
    CURRENCY: {
        definition: {
            title: 'New Currency Project',
            headerContent: '',
            pages: {
                pageContent: [
                    {
                        title: '',
                        subtitle: '',
                        content: {
                            entityMap: {},
                            blocks: [
                                {
                                    key: '637gr',
                                    text: '',
                                    type: 'unstyled',
                                    depth: 0,
                                    inlineStyleRanges: [],
                                    entityRanges: [],
                                    data: {},
                                },
                            ],
                        },
                    },
                ],
            },
            ownerId: -1,
            book: 'Book',
            projectName: 'projectName',
        },
        book: 'bucketName',
    },
};

export default DEFAULT_ASSET;



// WEBPACK FOOTER //
// ./src/enums/DefaultAsset.js